var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subscription-pay"},[_c('div',{staticClass:"pay-top-bar"},[_c('el-button',{attrs:{"type":"text","icon":"el-icon-arrow-left"},on:{"click":_vm.goBack}},[_vm._v("Back")])],1),_c('div',{staticStyle:{"padding":"20px","background":"#fff"},attrs:{"id":"checkout"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }